import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";
import {StorageKeysEnum} from "../../lib/storage/storage-keys.enum";
import * as pubsub from 'pubsub-js'
import {DashboardService} from "../../lib/services/dashboard/dashboard.service";
import {UserInfo} from "../../lib/models/user-info.model";
import {UserUtilsService} from "../../lib/services/user/user-utils.service";
import {ContractsUtils} from "../../lib/user/contracts/contracts.utils";
import {command} from '../../layout/sidebar/menu';
import {firstValueFrom} from "rxjs";
export const BASELINK = '/nueva-banca-digital'
@Component({
  selector: 'app-pending-authorizations-modal',
  templateUrl: './pending-authorizations-modal.component.html',
  styleUrls: ['./pending-authorizations-modal.component.scss']
})
export class PendingAuthorizationsModalComponent  implements  OnInit{
  loading: boolean = false
  @Output() closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Input() successRequest: any;
  @Input() pendingAuthPayments: any;
  @Input() pendingAuthRecipients: any;
  @Input() pendingAuthPaymentMancomunado: any;
  allContracts: UserInfo[] = [];
  contractSelected!: UserInfo | undefined;
  translateMessages: any;

  constructor(
      private router : Router,
      private dashboardService: DashboardService,
      private userUtilsService: UserUtilsService,
      private contractUtils: ContractsUtils,
  ) {
  }

  async ngOnInit(){
    this.allContracts = this.contractUtils.getContractsByServices()
    const userInfo = this.userUtilsService.getUserInfoSessionStorage()
    this.contractSelected = Array.isArray(userInfo?.contrato) ? userInfo?.contrato[0] : userInfo.contrato;
    const contract = this.dashboardService.getCurrentContract()?.idContrato || this.contractSelected?.idContrato || this.allContracts[0].idContrato
  }
  closeModal() {
    this.closeModalEvent.emit();
  }

  goNotificationCenter(){
    if (this.pendingAuthPayments != "" ){
      this.changeContract(this.pendingAuthPayments)
      command('NOTIFICATIONS', 'CMP_CARGA')
      this.router.navigate([BASELINK+`/pagos/autorizacion/single`])
    }else if( this.pendingAuthPaymentMancomunado != ""){
      this.changeContract(this.pendingAuthPaymentMancomunado)
      command('idMancomunidadMenu', 'idMancomunidadAutorizacionMenu')
      this.router.navigate([BASELINK+`/pagos/mancomunados/autorizacion`])
    } else if( this.pendingAuthRecipients != ""){
      this.changeContract(this.pendingAuthRecipients)
      command('NOTIFICATIONS', 'CMD_CARGA')
      this.router.navigate([BASELINK+`/destinatarios/autorizacion/single`])
    }
    this.closeModal()
  }

  changeContract(contractId?: any) {
    this.contractSelected = this.allContracts.find(x => x.idContrato == contractId)
    const userInfo = this.userUtilsService.getUserInfoSessionStorage()
    sessionStorage.setItem(StorageKeysEnum.USER_INFO, JSON.stringify({
      ...userInfo,
      contrato: this.contractSelected,
    }));
    this.dashboardService.updateContract(this.contractSelected)
    pubsub.publish("contract", this.contractSelected)
  }


}
